import { ClientManagerForm } from "../../../../Components/secure/clientManager/ClientManagerForm";
import { Container, Header, Divider } from "semantic-ui-react";
import { RouteComponentProps, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface RouteParams {
  id: string;
}

export const EditClientManager: React.FC<RouteComponentProps<RouteParams>> = () => {
  const { id } = useParams<RouteParams>();
  const { t } = useTranslation();
  return (
    <Container>
      <Header as="h1">{t("ClientManager.Edit")}</Header>
      <Divider />
      <ClientManagerForm id={id} />
    </Container>
  )
}